// extracted by mini-css-extract-plugin
export default {"themeBtn":"ThemeChanger_themeBtn__sxOWF","App-logo-spin":"ThemeChanger_App-logo-spin__-zhNE"};